import React, { useState, useEffect } from "react";
import Avatar from "@material-ui/core/Avatar";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import customTheme from "config/theme";
import defaultUserImg from "asset/img/default-avatar.jpg";

interface AvatarProps {
  src: string | null;
  onClick?: () => void;
  className?: string;
  alt?: string;
  children?: React.ReactNode;
  size?: number;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    avatar: {
      width: 160,
      height: 160,
      border: `2px solid ${(customTheme as any).bgPrimary}`,
      cursor: "pointer",
    },
    avatarContainer: {
      position: "relative",
      display: "inline-block",
    },
    loadingOverlay: {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "rgba(255, 255, 255, 0.7)",
      borderRadius: "50%",
      zIndex: 1,
    },
  })
);

const CustomAvatar: React.FC<AvatarProps> = ({
  src,
  onClick,
  className,
  alt,
  children,
  size = 150,
}) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (src) {
      setLoading(true);

      // Preload image to detect when it's loaded
      const img = new Image();
      img.src = src;

      img.onload = () => {
        setLoading(false);
      };

      img.onerror = () => {
        setLoading(false);
      };
    } else {
      setLoading(false);
    }
  }, [src]);

  return (
    <div className={classes.avatarContainer}>
      <Avatar
        src={src || defaultUserImg}
        alt={alt ? alt : "A"}
        className={
          className
            ? `${className}`
            : `${classes.avatar} ${
                size ? `width: ${size}px; height: ${size}px;` : ""
              }`
        }
        onClick={onClick}
      >
        {children}
      </Avatar>
      {loading && src && (
        <div className={classes.loadingOverlay}>
          <CircularProgress size={size * 0.2} />
        </div>
      )}
    </div>
  );
};

export default CustomAvatar;
